// extracted by mini-css-extract-plugin
export default {"signupWrapper":"styles_signupWrapper__sY2ye","progressBar":"styles_progressBar__IUpbB","active":"styles_active__32sqc"};